import React from "react";
import { createSvgIconComponent } from "../";

export const IconClubCatchMonitor = createSvgIconComponent({
  viewBox: "0 0 67 54",
  fill: "none",
  children: (
    <>
      <g clipPath="url(#icon-cc-monitor-clip)">
        <path
          d="M33.958 11.302H25.81a3.918 3.918 0 00-3.664 2.563l-.027.056-2.898 9.964a3.104 3.104 0 00.478 2.84 3.972 3.972 0 003.049 1.378h11.21a4.067 4.067 0 003.431-1.571l3.459-4.728c.52-.592.806-1.35.834-2.15a3.277 3.277 0 00-.807-2.095c-.287-.386-2.789-3.749-3.39-4.562a4.358 4.358 0 00-3.527-1.695zm6.644 8.366a2.506 2.506 0 01-.63 1.557l-3.458 4.728a3.008 3.008 0 01-2.556 1.13h-11.21a2.887 2.887 0 01-2.174-.965 2.062 2.062 0 01-.3-1.943l2.898-9.937.013-.028a2.82 2.82 0 012.639-1.86h8.147a3.21 3.21 0 012.639 1.267c.602.827 3.117 4.19 3.39 4.576.37.4.575.924.602 1.475z"
          fill="currentColor"
        />
        <path
          d="M33.849 13.493h-8.025a1.677 1.677 0 00-1.504 1.089l-2.884 9.896c-.41 1.42 1.326 1.447 1.326 1.447h11.21a1.668 1.668 0 001.544-.62l3.46-4.728c.273-.386.437-.592.437-.923a1.338 1.338 0 00-.356-.786s-2.789-3.748-3.431-4.617a2.174 2.174 0 00-1.777-.758zm.806 5.114H31.28c.177-.828 0-1.503-.889-1.503-1.258 0-1.818 1.227-2.16 2.77-.506 2.275.041 2.798.889 2.798 1.162 0 1.476-1.116 1.627-1.778h3.445c-.479 2.22-2.639 3.639-5.4 3.639-2.912 0-4.799-1.489-4.102-4.659.588-2.866 3.213-4.851 6.111-4.63a4.231 4.231 0 013.404 1.254c.465.606.615 1.378.451 2.108zm2.27.013a1.274 1.274 0 011.298 1.255 1.283 1.283 0 01-1.298 1.254 1.283 1.283 0 01-1.3-1.255 1.283 1.283 0 011.3-1.254z"
          fill="currentColor"
        />
        <path
          d="M55.366 0H3.732C1.722-.04.055 1.558 0 3.584v36.965c0 2.08 1.805 3.597 4.293 3.597h19.03l-1.887 8.145h-3.527c-.165 0-.315.138-.315.303v1.103c0 .165.137.303.315.303h23.253c.165 0 .315-.138.315-.303v-1.103a.308.308 0 00-.315-.303h-3.527l-1.886-8.145h7.136c.164 0 .314-.138.314-.303V42.74c0-.165-.15-.303-.314-.303H4.293c-1.504 0-2.516-.758-2.516-1.889v-2.977H42.9a.32.32 0 00.328-.303v-1.102a.32.32 0 00-.328-.303H1.777V3.597c.028-1.062.902-1.916 1.955-1.889h51.634c1.053-.027 1.928.813 1.955 1.889v23.36h1.777V3.599A3.664 3.664 0 0055.366 0zM33.958 44.146l1.886 8.145H23.267l1.887-8.145h8.804z"
          fill="currentColor"
        />
        <path
          d="M55.927 50.706c-6.111 0-11.074-5.003-11.074-11.164 0-6.16 4.963-11.164 11.074-11.164 6.11 0 11.073 5.003 11.073 11.164 0 6.16-4.962 11.164-11.073 11.164zm0-20.674c-5.195 0-9.433 4.273-9.433 9.51s4.238 9.51 9.433 9.51c5.195 0 9.432-4.273 9.432-9.51s-4.224-9.51-9.432-9.51z"
          fill="#F0D511"
        />
        <path
          d="M59.344 41.747H53.74v-5.65c0-.455.37-.828.82-.828.452 0 .82.373.82.828v3.996h3.965c.451 0 .82.372.82.827a.817.817 0 01-.82.827z"
          fill="#F0D511"
        />
      </g>
      <defs>
        <clipPath id="icon-cc-monitor-clip">
          <path fill="#fff" d="M0 0h67v54H0z" />
        </clipPath>
      </defs>
    </>
  ),
});
